import {useI18n} from 'i18n/I18nContext'
import {useOrganizationEventsList} from 'organization/ListEvents/providers/OrganizationEventsListProvider'
import {Loader} from 'organization/theme/Loader'
import React from 'react'
import {createPortal} from 'react-dom'
import styled from 'styled-components'
import ExampleTemplateItem from 'TemplateEditor/Layout/Sidebar/ExampleTemplates/ExampleTemplateItem'
import {
  ExampleTemplate,
  useExampleTemplates,
} from 'TemplateEditor/Layout/Sidebar/ExampleTemplates/ExampleTemplatesProvider'

export default function ExampleTemplateModal(props: {
  isOpen: boolean
  toggleOpen: () => void
}) {
  const {isOpen, toggleOpen} = props
  const {t} = useI18n()

  const {exampleTemplates} = useExampleTemplates()
  const {events} = useOrganizationEventsList()

  return createPortal(
    <>
      <div
        role="presentation"
        onClick={toggleOpen}
        className={`offcanvas__overlay template-editor-design-popup-overlay ${isOpen ? 'overlay-open' : ''}`}
      />
      <section
        className={`event__popup-area template-editor-design-popup ${isOpen ? 'open' : ''}`}
        style={{maxWidth: '80%'}}
        aria-modal="true"
        role="dialog"
      >
        <div className="popup__wrapper">
          <div className="popup__title-wrapper">
            <h3 className="popup__title">
              {t('templateEditor.exampleDesignsTitle')}
            </h3>
          </div>
          <div className="popup__input-wrapper">
            {(!exampleTemplates || exampleTemplates.length === 0) && <Loader />}
            {exampleTemplates &&
              exampleTemplates.length !== 0 &&
              exampleTemplates.map((item: ExampleTemplate) => {
                return (
                  <ExampleTemplateItem
                    key={item.id ?? `${item.locale ?? ''}-${item.name}`}
                    exampleTemplate={item}
                    toggleOpen={toggleOpen}
                  />
                )
              })}
          </div>
          <div className="popup__input-wrapper">
            <EventListTitle>{t('templateEditor.fromOrgEvents')}</EventListTitle>

            {events.length === 0 && (
              <div style={{color: '#999'}}>
                {t('templateEditor.noOrgEvents')}
              </div>
            )}
            {events.length > 0 &&
              events.map((event) => {
                if (event.template) {
                  const exampleTemplate: ExampleTemplate = {
                    name: event.name,
                    image: null,
                    template: event.template,
                  }
                  return (
                    <EventTemplateHolder>
                      <ExampleTemplateItem
                        key={event.id}
                        exampleTemplate={exampleTemplate}
                        toggleOpen={toggleOpen}
                      />
                    </EventTemplateHolder>
                  )
                }

                return null
              })}
          </div>
        </div>
      </section>
    </>,
    document.body,
  )
}

const EventTemplateHolder = styled.div`
  border-top: 1px solid #ccc;
  padding-top: 10px;
  padding-bottom: 10px;
`

const EventListTitle = styled.h4`
  margin-bottom: 15px;
  margin-top: 30px;
`
